// DEV
// export const API_URL = "http://127.0.0.1:8000";
// export const IS_PROD = false;
// export const WEBSITE_DOMAIN = "cubits.ai";

// PROD
export const API_URL = "https://www.api.cubits.ai";
export const IS_PROD = true;
export const WEBSITE_DOMAIN = "cubits.ai";
